// Types
import { Content, TargetedPerformanceBonusContent } from "../../../../types/sections/technicians";

// Constants
import { DEFAULT_KEYS } from "./constants";

const isDisabledAdd = ({ isValidModels, innerModels = [] }: { isValidModels: boolean; innerModels: TargetedPerformanceBonusContent[] }) =>
	!isValidModels && Boolean(innerModels?.length);

const generateEmptyDepartmentsModel = (): TargetedPerformanceBonusContent => ({
	tiers: [
		{
			from: { input: "Duration", value: 0 },
			to: { input: "Duration", value: 744 },
			commissions: [
				{
					from: { input: "Unit", value: 0 },
					to: { input: "Unit", value: 744 },
					commission: { input: "Duration", value: 0 },
				},
			],
		},
	],
	applyTiersRetroactively: false,
	selectedPayType: ["Customer"],
	selectedDepartment: [],
	component: "LABOR",
	isValid: false,
});

const generateEmptyOperationsModel = (): TargetedPerformanceBonusContent => ({
	tiers: [
		{
			from: { input: "Duration", value: 0 },
			to: { input: "Duration", value: 744 },
			commissions: [
				{
					from: { input: "Unit", value: 744 },
					to: { input: "Unit", value: 0 },
					commission: { input: "Duration", value: 0 },
				},
			],
		},
	],
	applyTiersRetroactively: false,
	selectedPayType: ["Customer"],
	selectedOperationCodes: [
		{
			code: "",
			type: "Generic",
			pay: ["Customer"],
		},
	],
	selectedTimeLapse: "",
	component: "LABOR",
	isValid: false,
});

const generateInnerModel = (content?: Content | null) => {
	return {
		departments: content?.departments?.length
			? content.departments.map((deps: TargetedPerformanceBonusContent) => ({ ...deps, isValid: true }))
			: [],
		operationCodes: content?.operationCodes?.length
			? content.operationCodes.map((opCodes: TargetedPerformanceBonusContent) => ({ ...opCodes, isValid: true }))
			: [],
	} as Content;
};

const isValidModels = (models: Content) => {
	const validDeps =
		!models[DEFAULT_KEYS.DEPARTMENTS_KEY].length ||
		models[DEFAULT_KEYS.DEPARTMENTS_KEY].every((model: TargetedPerformanceBonusContent) => model.isValid);
	const validOpCodes =
		!models[DEFAULT_KEYS.OPERATION_CODES_KEY].length ||
		models[DEFAULT_KEYS.OPERATION_CODES_KEY].every((model: TargetedPerformanceBonusContent) => model.isValid);
	return { validDeps, validOpCodes };
};

const areAllEmpty = (innerModels: Content) => {
	return !innerModels.operationCodes?.length && !innerModels.departments?.length;
};

export { isDisabledAdd, generateEmptyDepartmentsModel, generateEmptyOperationsModel, generateInnerModel, isValidModels, areAllEmpty };
